export class CompanyFeatures {
  features: number[] = [];
  hasCredit: boolean = false;
  canShowFees: boolean = false;
  canShowAllProducts: boolean = false;
  canShowAnalytics: boolean = false;
  canSell: boolean = false;

  constructor(features: number[]) {
    this.features = features;
    this.hasCredit = CompanyUtility.hasCredit(features);
    this.canShowFees = CompanyUtility.canShowFees(features);
    this.canShowAllProducts = CompanyUtility.canShowAllProducts(features);
    this.canShowAnalytics = CompanyUtility.canShowAnalytics(features);
    this.canSell = CompanyUtility.canSell(features);
  }
}

const features = {
  hasCredit: 1,
  showFees: 2,
  showAllProducts: 3,
  showAnalytics: 4,
  canSell: 5
};

export class CompanyUtility {
  static hasCredit = (companyFeatures: number[] | undefined): boolean =>
    this.hasFeature(companyFeatures, features.hasCredit);

  static canShowFees = (companyFeatures: number[] | undefined): boolean =>
    this.hasFeature(companyFeatures, features.showFees);

  static canShowAllProducts = (companyFeatures: number[] | undefined): boolean =>
    this.hasFeature(companyFeatures, features.showAllProducts);

  static canShowAnalytics = (companyFeatures: number[] | undefined): boolean =>
    this.hasFeature(companyFeatures, features.showAnalytics);

  static canSell = (companyFeatures: number[] | undefined): boolean =>
    this.hasFeature(companyFeatures, features.canSell);

  private static hasFeature = (companyFeatures: number[] | undefined, feature: number): boolean =>
    companyFeatures?.some((f: number) => f === feature) || false;
}
